import React, { ReactElement } from 'react';
import { Header as StyledHeader, Wrapper as StyledWrapper } from './SectionTitle.styled';
import { ComponentProps as Props } from './SectionTitle.types';
import Text from '../../atoms/Text/Text';

const SectionTitle: React.FC<Props> = ({ title, subtitle }): ReactElement<Props> => {
  return (
    <StyledWrapper mb={11}>
      <StyledHeader mode="heading" mb={2}>
        {title}
      </StyledHeader>
      {subtitle && <Text color="light">{subtitle}</Text>}
    </StyledWrapper>
  );
};

export default SectionTitle;
